// SecureStore wrapper for web compatibility
import * as ExpoSecureStore from 'expo-secure-store';

const isWeb = typeof window !== 'undefined' && typeof document !== 'undefined';
const STORAGE_PREFIX = '@SecureStore:';

// Web fallback using localStorage
const webSecureStore = {
  async getItemAsync(key: string): Promise<string | null> {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }
    try {
      const storageKey = STORAGE_PREFIX + key;
      const value = window.localStorage.getItem(storageKey);
      return value;
    } catch (error) {
      console.warn('SecureStore.getItemAsync error:', error);
      return null;
    }
  },

  async setItemAsync(key: string, value: string): Promise<void> {
    if (typeof window === 'undefined' || !window.localStorage) {
      throw new Error('localStorage is not available');
    }
    try {
      const storageKey = STORAGE_PREFIX + key;
      window.localStorage.setItem(storageKey, value);
    } catch (error) {
      console.error('SecureStore.setItemAsync error:', error);
      throw error;
    }
  },

  async deleteItemAsync(key: string): Promise<void> {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }
    try {
      const storageKey = STORAGE_PREFIX + key;
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      console.warn('SecureStore.deleteItemAsync error:', error);
    }
  },
};

// Export platform-specific implementation
export const getItemAsync = isWeb
  ? webSecureStore.getItemAsync
  : ExpoSecureStore.getItemAsync;

export const setItemAsync = isWeb
  ? webSecureStore.setItemAsync
  : ExpoSecureStore.setItemAsync;

export const deleteItemAsync = isWeb
  ? webSecureStore.deleteItemAsync
  : ExpoSecureStore.deleteItemAsync;

export default {
  getItemAsync,
  setItemAsync,
  deleteItemAsync,
};
